import Backbone from 'backbone'
import { Chatbox } from './chatbox';
import T from './testchatbox.html'

const loremWords = "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum".split(' ')

const testChildView = M.View.extend({
    template: _.template('<strong>ID (<%=id%>) <%=username%></strong><br /><%=message%>'),
    className: 'message'
})

const startingId = 54389;
let oldId = startingId - 1

export const testchatbox = M.View.extend({
    template: _.template(T),
    regions: {
        'chatbox': '.chatbox-container'
    },
    ui: {
        'width':'.width',
        'height':'.height',
        'count':'.count',
        'chatbox':'.chatbox-container'
    },
    triggers: {
        'click .btAddNew':'add:new',
        'click .btAddOld':'add:old',
        'click .reset':'reset',
    },
    initialize: function(){
        this.collection = new Backbone.Collection();
    },
    onRender: function(){
        this.ui.chatbox.css({
            width: this.ui.width.val() + 'px',
            height: this.ui.height.val() + 'px',
        })
        this.onReset();
    },
    newItems: function(cpt, oldItem){
        const out = []
        for(var i = 0; i < (cpt ? cpt : 1); i++){
            out.push({
                id: oldItem ? --oldId : (startingId + this.collection.length + (i + 1)),
                username: 'Simon',
                message: this.randomMessage(Math.floor(Math.random() * 20) + 5)
            })
        }
        return out;
    },
    randomWord: function(){
        return loremWords[Math.floor(Math.random() * loremWords.length)]
    },
    randomMessage: function(wordCount){
        return _.times(wordCount, (count) => {
            return this.randomWord() + ' '
        }).join(' ')
    },
    onAddNew: function(){

        this.collection.add(this.newItems(parseInt(this.ui.count.val())))
        
    },
    onAddOld: function(){

        this.collection.add(this.newItems(parseInt(this.ui.count.val()), true))

    },
    onReset: function(){

        this.collection.reset(this.newItems(parseInt(this.ui.count.val())))

        this.showChildView('chatbox', new Chatbox({
            collection: this.collection,
            childView: testChildView,
            viewComparator: 'id'
        }))

    }
})